module.exports = __webpack_public_path__ + "media/images/banner-text-890f444f2a7d8a1c5c999a8b837ac311.svg";